module.exports = __webpack_public_path__ + "media/images/icons/person-123c21446ed1ac661e70fc2d849aa1e4.svg";